import React, { useEffect, useRef, useState } from "react";

//utilities
import { getContentIdFromContentUrl } from "../search/utility";

//hooks
import useHTTP from "@/components/hooks/useHTTP";

//interfaces
import { IAcknowledgementsProps } from "@/interfaces/acknowledgements";

//components
import AcknowledgementGroup from "./AcknowledgementGroup";
import AcknowledgementsOverview from "./AcknowledgementsOverview";



const Acknowledgements: React.FC<IAcknowledgementsProps> = ({isAckEnabled, isOrgAdmin, appId, contentIsArchived }) => {
    const { get } = useHTTP();

    const [contentId, setContentId] = useState<string>(getContentIdFromContentUrl(window.location.href));
    const [version, setVersion] = useState<string>(getVersionId().toString());
    const contentIdObserver = new MutationObserver((mutation: any[]) => setContentId(mutation[0].target.value));  
    const versionObserver = new MutationObserver((mutation: any[]) => setVersion(mutation[0].target.value));  
 
    const [acknowledgementsGroup, setAcknowledgementsGroup] = useState<{ groupName: string, id: any }>({ groupName: undefined, id: undefined});
    const [responses, setResponseRate] = useState<any>();
    const [acknowledgementStatus, setAcknowledgementStatus] = useState<string>();
    const [showSegmentationWarning, setShowSegmentationWarning] = useState<boolean>(false);

    const contentIdRef = useRef<string>(contentId)

    useEffect(() => {
      contentIdRef.current = contentId
    },[contentId]);

    
    // whenever content version changes refresh the data
    useEffect(() => {
      getData();
      (window as any).refreshAcknowledgements = getData;
    }, [version])

    useEffect(() => {
      
    },[])

    function getResponseRate() {
      if (contentId) {
        get(`content/${appId}/ackresponserate/${contentIdRef.current}`)
        .then(({ data }) => {
          setResponseRate(data.rate);
        })
        .catch((error) => {
          if (error.response.request.status === 400){
            setResponseRate(0);
            
          } else {
            console.error(error.message);
          }
        });
      }
    }

    function getAcknowledgementGroup() {
      get(`content/${appId}/content/${contentId}/ackgroup`)
      .then(({ data }) => {
        setAcknowledgementsGroup({groupName: data.groupName, id: data.id});
      })
      .catch((error) => {
        if (error.response.status === 400 && error.response.data === "Acknowledgements Group not found"){
          setAcknowledgementsGroup({groupName: undefined, id: undefined});
        } else {
          console.error(error.message);
        }
      });
    }

    function showDivider(){
      return  (!acknowledgementStatus && isAckEnabled && showSegmentationWarning) || acknowledgementStatus || (contentId && isAckEnabled);
    }

    function getVersionId() { 
      return (document.querySelector('#Version') as HTMLInputElement)?.value || 0;
    }

    useEffect(() => {
      /* hidden read only id field exists on page, because its read only we cannot bind an on change event like you would expect, so we have to use a mutation observer
        this will update when a content id is set on save or save and publish
      */
      if(document.querySelector('#Id')) {
        contentIdObserver.observe(document.querySelector('#Id'), {attributes: true, childList: true})
      }

      if(document.querySelector('#Version')) {
        versionObserver.observe(document.querySelector('#Id'), {attributes: true, childList: true})
      }
      return () => {
        contentIdObserver.disconnect();
        versionObserver.disconnect();
      }
    }, []);

    const getData = () => {
      getResponseRate();
      getAcknowledgementGroup(); 
    }

    useEffect(() => {
      if(contentId) {
        getData();
      }
    }, [contentId])

    const ackEnabledOrHasPreviousResponses = () => isAckEnabled||responses?.rate > 0.0;

    return (
        <div className="acknowledgements-container" data-testid="acknowledgements-container">

            {showDivider() && <div className="divider" />}

            {contentId && ackEnabledOrHasPreviousResponses() &&
            <>
              <AcknowledgementsOverview responses={responses} contentIsArchived={contentIsArchived}/>
              { (isAckEnabled && !contentIsArchived) && 
                <AcknowledgementGroup acknowledgementsGroup={acknowledgementsGroup} isOrgAdmin={isOrgAdmin} appId={appId} getAcknowledgementGroup={getAcknowledgementGroup}/>
              }
            </>
            }
            
         
        </div>
    );
  }

export default Acknowledgements;
